import React from 'react'
import styled from 'styled-components'
import type {SearchResult} from '../Search'

interface SearchResultItemProps extends SearchResult {
  isActive?: boolean
  onSelectTemplate?: (template: SearchResult) => void
  onMouseEnter?: React.MouseEventHandler<HTMLAnchorElement>
  onMouseLeave?: React.MouseEventHandler<HTMLAnchorElement>
  onFocus?: React.FocusEventHandler<HTMLAnchorElement | HTMLButtonElement>
  onBlur?: React.FocusEventHandler<HTMLAnchorElement | HTMLButtonElement>
}

const SearchResultLink = styled.a<{isActive?: boolean}>`
  display: block;
  color: #050038;
  cursor: pointer;

  ${({theme}) =>
    theme.normalizeStyles({
      paddingTop: 12,
      paddingBottom: 12,
      paddingLeft: 16,
      paddingRight: 16,
      borderRadius: 4,
      fontSize: 16,
      lineHeight: 20,
    })}

  ${({theme, isActive}) =>
    isActive &&
    theme.normalizeStyles({
      backgroundColor: [null, '#f0f0f3', '#f0f0f3', '#f0f0f3'],
    })}
`

const SearchResultItem: React.FC<SearchResultItemProps> = ({
  title,
  description,
  preview,
  href,
  slug,
  onSelectTemplate,
  ...props
}) => (
  <SearchResultLink
    href={href}
    onClick={e => {
      if (onSelectTemplate) {
        e.preventDefault()
        onSelectTemplate({title, description, preview, href, slug})
      }
    }}
    {...props}
  >
    {title}
  </SearchResultLink>
)

export default SearchResultItem
